function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.9322 15.9398L7.99243 7.99243V25.9585C7.99243 28.0522 9.18566 29.8533 10.9417 30.7089L23.9547 37.2154L36.9677 30.7089C38.7013 29.8308 39.917 28.0297 39.917 25.9585V7.99243L23.9322 15.9398Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M50.3859 14.5215L52.8849 20.8704L55.4289 14.5215H57.4327L53.4477 23.9548H52.277L48.3596 14.5215H50.3859Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M68.7797 23.9548V20.1725H69.0273L71.5714 23.9548H73.8453L70.8735 19.9698C72.3143 19.6772 73.0348 18.7991 73.0348 17.3132C73.0348 16.5252 72.7871 15.8723 72.2918 15.3545C71.7515 14.7916 70.8735 14.5215 69.7027 14.5215H66.9561V23.9548H68.7797V23.9548ZM68.7797 16.0074H69.3425C70.5358 16.0074 71.1211 16.4802 71.1211 17.4258C71.1211 18.3939 70.5132 18.8667 69.32 18.8667H68.7797V16.0074Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M76.9072 14.5215V19.9248C76.9072 20.5102 76.9297 20.8929 76.9747 21.073C77.0423 21.3207 77.1323 21.5458 77.2899 21.7709C77.6501 22.2662 78.168 22.4914 78.8434 22.4914C79.5188 22.4914 80.0366 22.2437 80.3968 21.7709C80.5544 21.5683 80.667 21.3207 80.712 21.073C80.7571 20.8929 80.7796 20.4876 80.7796 19.9248V14.5215H82.6257V20.285C82.6257 21.5233 82.3105 22.4463 81.7026 23.0767C80.9822 23.7972 80.0366 24.1574 78.8434 24.1574C77.6501 24.1574 76.682 23.7972 75.9841 23.0767C75.3762 22.4463 75.061 21.5008 75.061 20.285V14.5215H76.9072Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M86.6557 18.1687H90.6406V14.5215H92.4867V23.9548H90.6406V19.7672H86.6557V23.9548H84.832V14.5215H86.6557V18.1687Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M100.794 22.3788H105.139V23.9548H97.7324L102.348 16.1425H98.4529V14.5215H105.387L100.794 22.3788Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M109.44 23.9548C110.971 23.9548 112.209 23.482 113.132 22.5814C114.055 21.6584 114.528 20.5552 114.528 19.2269C114.528 17.9211 114.077 16.8179 113.177 15.8948C112.254 14.9718 111.016 14.5215 109.462 14.5215H106.76V23.9548H109.44ZM108.607 16.1425H109.102C109.755 16.1425 110.295 16.21 110.723 16.3451C111.151 16.5027 111.511 16.7278 111.826 17.0655C112.389 17.6509 112.659 18.3713 112.659 19.2494C112.659 20.1049 112.389 20.8254 111.826 21.4332C111.533 21.7709 111.173 22.0186 110.723 22.1537C110.295 22.3113 109.755 22.3788 109.102 22.3788H108.607V16.1425Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M117.725 23.9548V20.1725H117.972L120.516 23.9548H122.79L119.818 19.9698C121.259 19.6772 121.98 18.7991 121.98 17.3132C121.98 16.5252 121.732 15.8723 121.237 15.3545C120.696 14.7916 119.818 14.5215 118.648 14.5215H115.901V23.9548H117.725V23.9548ZM117.725 16.0074H118.287C119.481 16.0074 120.066 16.4802 120.066 17.4258C120.066 18.3939 119.458 18.8667 118.265 18.8667H117.725V16.0074Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M133.845 14.5215L136.366 20.8704L138.91 14.5215H140.914L136.929 23.9548H135.758L131.841 14.5215H133.845Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M144.674 14.5215V20.8929C144.674 22.1311 144.404 23.0092 143.841 23.527C143.368 23.9548 142.783 24.1799 142.085 24.1799C141.252 24.1799 140.531 23.8872 139.878 23.3019L140.981 21.9736C141.229 22.3338 141.522 22.4914 141.882 22.4914C142.242 22.4914 142.49 22.3563 142.625 22.0861C142.76 21.816 142.828 21.3432 142.828 20.6002V14.5215H144.674Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M61.215 17.0881L63.9167 23.9548H65.8979L62.003 14.5215H60.4495L56.4646 23.9548H58.4008L61.215 17.0881Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M125.447 23.6621L127.451 18.7766L128.126 17.0881L128.149 17.1106V17.0881L130.85 23.9548H132.809L128.914 14.5215H127.383L123.376 23.9548H125.312L125.447 23.6621Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M150.527 17.0881V17.1106V17.0881L151.856 20.4876L152.869 23.0542L153.229 23.9548H155.21L151.315 14.5215H149.784L145.777 23.9548H147.713L150.527 17.0881Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M86.0253 28.4348L87.2635 31.5417L88.5243 28.4348H89.2672L87.2635 33.2303L85.3048 28.4348H86.0253Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M90.5054 32.2622H92.6442V32.8926H89.4022L91.5861 29.0652H89.7399V28.4348H92.6892L90.5054 32.2622Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M96.179 31.8121H94.2653L93.77 32.8927H93.0496L95.2559 28.1423L97.3947 32.8927H96.6518L96.179 31.8121ZM95.9088 31.1817L95.2559 29.6733L94.558 31.1817H95.9088Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M99.421 28.4349V31.3166C99.421 31.6543 99.3985 31.902 99.3534 32.0821C99.3084 32.2847 99.2184 32.4423 99.1058 32.5774C98.8807 32.8476 98.588 32.9827 98.2052 32.9827C97.9125 32.9827 97.6649 32.9151 97.4172 32.7575L97.7549 32.1722C97.9125 32.2847 98.0701 32.3298 98.2277 32.3298C98.4304 32.3298 98.5655 32.2622 98.633 32.1046C98.7231 31.947 98.7681 31.6769 98.7681 31.2941V28.4124H99.421V28.4349Z",
  fill: "white"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M103.091 29.0652H101.312V30.1459H103.046V30.7763H101.312V32.2622H103.091V32.8926H100.637V28.4348H103.091V29.0652Z",
  fill: "white"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M103.924 32.8926L104.869 28.0972L106.4 31.5643L107.999 28.0972L108.832 32.8926H108.134L107.706 30.191L106.378 33.0952L105.094 30.191L104.622 32.8926H103.924Z",
  fill: "white"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M109.53 32.8926V28.1196L112.794 31.5192V28.4123H113.47V33.1627L110.205 29.7631V32.8926H109.53V32.8926Z",
  fill: "white"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M117.072 31.8121H115.158L114.663 32.8927H113.942L116.149 28.1423L118.287 32.8927H117.545L117.072 31.8121ZM116.802 31.1817L116.149 29.6733L115.451 31.1817H116.802Z",
  fill: "white"
});

var _ref23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 7.98516,
  y1: 22.5898,
  x2: 39.8945,
  y2: 22.5898,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.000239811,
  stopColor: "#00AAF0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0064B9"
})));

var SvgVzLogoSekundarniRgb = function SvgVzLogoSekundarniRgb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 46,
    viewBox: "0 0 163 46",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVzLogoSekundarniRgb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/VZ_LOGO_sekundarni_RGB.84bd1db0.svg";
export { ForwardRef as ReactComponent };